/**
 * 微信相关接口（签名、二维码）
 */
import { postForm, request } from './request'

/**
 * 获取微信 JS-SDK 签名配置
 * @param {string} url 当前页面 URL（不含 # 及之后部分）
 */
export function getWechatSignature(url) {
  return postForm('/admin/empuser/weixin/signature', { url })
}

/**
 * 生成分享二维码（返回 base64 字符串）
 * @param {string} url 当前页面 URL（不含 # 及之后部分）
 */
export async function generateShareCode(url) {
  const res = await request('/admin/code/generate', {
    method: 'POST',
    body: `url=${encodeURIComponent(url)}`,
    raw: false,
  })
  // 该接口返回纯文本 base64，无 json 包装
  return typeof res === 'string' ? res : res
}



// WEBPACK FOOTER //
// ./src/api/wechat.js